/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ImageRegistryPermissions {
	PULL = "pull",
	PUSH = "push",
	LIBRARY_PUSH = "library_push",
}
